// extracted by mini-css-extract-plugin
export default {"card":"Team_card__-BRVy","image":"Team_image__l+obQ","social":"Team_social__DQdXu","title":"Team_title__8Q432","subtitle":"Team_subtitle__tUJdY","text":"Team_text__4lun2"};